import {
  Component, ViewEncapsulation, AfterViewInit, ViewChild, Inject
} from '@angular/core';
import {DOCUMENT, Meta, Title} from '@angular/platform-browser'
import {ActivatedRoute} from "@angular/router";
import { BASE_URL, API_VERSION } from '../shared/base.url';
import { LoopBackConfig } from '../shared/sdk/lb.config';
import { TransferState } from '../../modules/transfer-state/transfer-state';
import { ArticleUtils } from './../../../common/utils/articleutils';
import {Observable, AsyncSubject, ReplaySubject} from "rxjs";
import {StringUtils} from "../shared/services/stringutils";
import {DynamicTypeBuilder} from "../shared/type-builder/type.builder";
import {HeroAnimationService} from "../shared/animations/hero-animation.service";
import {Location} from "@angular/common";
import {StickyHeaderComponent} from "../shared/sticky-header/sticky-header.component";

declare var ga: any;

@Component({
  templateUrl: './article.component.html',
  styleUrls: [ './article.component.scss' ],
  selector: 'articleComponent',
  encapsulation: ViewEncapsulation.None,
/*  animations: [ routeAnimation ],
  host: {
    '[@routeAnimation]': 'true',
    '(@routeAnimation.start)': 'animStart($event)',
    '(@routeAnimation.done)': 'animEnd($event)',
    '[style.display]': "'block'",
    '[style.position]': "'absolute'",
    '[style.left]' : "'0'",
    '[style.right]' : "'0'"
  }*/
})

export class ArticleComponent implements AfterViewInit {

  public articleView: Observable<any>;
  public previousArticles: Array<any> = [];
  public showStickyHeader: boolean = true;
  protected articleData: any;
  protected articleAsyncSubject: AsyncSubject<any> = new AsyncSubject();
  protected isViewInitialized: boolean = false;
  protected previousArticlesReplaySubject = new ReplaySubject();
  protected previousArticleOffset: number;

  @ViewChild('stickyHeader') protected stickyHeader: StickyHeaderComponent;

  constructor(protected route: ActivatedRoute,
              protected articleUtils: ArticleUtils,
              protected meta: Meta,
              protected title: Title,
              protected cache: TransferState,
              protected heroAnimationService: HeroAnimationService,
              protected location: Location) {

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    this.meta.addTag({property: 'og:type', content: 'article'});

    this.route.url.subscribe((parts: any) => {

      //render a new article and clear infinite scroll:
      this.previousArticleOffset = 0;
      this.previousArticles = [];
      this.previousArticlesReplaySubject.complete();
      this.previousArticlesReplaySubject = new ReplaySubject();

      this.previousArticlesReplaySubject.subscribe((offset: number) => {
        if(this.articleData.view != 'undecoratedArticle') {
          this.articleUtils.loadPreviousArticle(this.articleData['publishDate'], offset)
            .subscribe((articleData: Array<any>) => {
              if (articleData != null && articleData.length > 0 && articleData[0] != null) {
                this.cache.set(articleData[0]['url'], articleData[0]);
                this.previousArticles.push(articleData[0]);
              }
            })
        }
      });

      this.renderArticle('/' + parts.join('/'));
    });

  }

  ngAfterViewInit() {

    this.articleAsyncSubject.subscribe(data => {
      this.renderMetaData(data);
    });
    this.isViewInitialized = true;

  }

  public changeActiveArticle(article) {

    this.stickyHeader.title = article.title;
    this.location.replaceState(article.url);

    this.stickyHeader.url = 'https://howmuch.net' + article.url;

    this.renderMetaData(article, this.stickyHeader.url);
  }

  protected renderMetaData(data, currentURL = null) {

    if(!!data['pageMetaTitle']) {
      this.title.setTitle(data['pageMetaTitle']);
    }

    if(!!data['pageMetaDescription']) {
      this.meta.updateTag({ name: 'description', content: data['pageMetaDescription']});
    }

    if(!!data['ogDescription']) {
      this.meta.updateTag({property: 'og:description', content: data['ogDescription']});
    }

    if(!!data['ogTitle']) {
      this.meta.updateTag({property: 'og:title', content: data['ogTitle']});
    }

    if(currentURL == null) {
      currentURL = ('https://howmuch.net' + data['url']);
    }

    this.meta.updateTag({property: 'og:url', content: currentURL});
    let imageUrl = data['unbrandedImage'].startsWith('http') ? data['unbrandedImage'] : ('https:' + data['unbrandedImage']);
    this.meta.updateTag({property: 'og:image', content: imageUrl});

    this.meta.updateTag({property: 'twitter:card', content: 'summary_large_image'});
    this.meta.updateTag({property: 'twitter:title', content: data['ogTitle']});
    this.meta.updateTag({property: 'twitter:description', content: data['ogDescription']});
    this.meta.updateTag({property: 'twitter:url', content: currentURL});
    this.meta.updateTag({property: 'twitter:image', content: imageUrl});
    this.meta.updateTag({property: 'twitter:site', content: '@howmuch_net'});

    if(!!data['view'] && data['view'] == 'undecoratedArticle') {
      this.showStickyHeader = false;
    }

    this.stickyHeader.ogDescription = data.ogDescription;
    this.stickyHeader.ogTitle = data.ogTitle;
    this.stickyHeader.twitterText = data.twitterText;

  }


  protected renderArticle(url: string) {

    let articleViewFromCache = this.cache.get(url);
    if(articleViewFromCache != null) {
      this.articleView = Observable.of(articleViewFromCache);
      this.articleData = articleViewFromCache;
    }
    else {
      this.articleView = this.articleUtils.loadArticle(url);
      //avoid call twice from client by storing the data in the cache
      this.articleView.subscribe(data => {
        this.cache.set(url, data);
        this.articleData = data;
      });
    }

    if(!this.isViewInitialized) {
      //use an async subject if the view has not been initialized
      this.articleView.subscribe(this.articleAsyncSubject);
    }
    else {
      this.articleView.subscribe(data => {
        this.renderMetaData(data);
      });
    }

  }

  public showArticle(article) {
    ga('send', 'pageview', article.url);
    $('#' + article.id + '_container').addClass('visible');
  }

  public renderPreviousArticle() {
    this.previousArticlesReplaySubject.next(this.previousArticleOffset ++);
  }

  protected animStart(event) {
    console.log('article:animStart');
    this.heroAnimationService.registerStartAnimationEvent(event);
  }

  protected animEnd(event) {
    console.log('article:animEnd');
  }


}



// WEBPACK FOOTER //
// ./src/app/article/article.component.ts